import { defineMessages } from "react-intl";
/* --- Content for status messages --- */
/* tslint:disable:max-line-length */
/* General status messages */
export const LOADING = defineMessages({
    GENERAL: {
        id: "statusMessage.loading.general",
        defaultMessage: "Loading, please wait."
    }
});
export const CAPTCHA = defineMessages({
    REQUIRED: {
        id: "statusMessage.captcha.required",
        defaultMessage: "There have been too many failed attempts to login. Recaptcha is now required. If you are having trouble logging in, please call us."
    }
});
/* Domain specific status messages */
export const ACCTS = defineMessages({
    INTRO_ACCTS: {
        id: "statusMessage.accts.introAccts",
        defaultMessage: "Your accounts weren't loaded or updated due to this error:"
    },
    /* For specific errors */
    INVALID_CRED_401: {
        id: "statusMessage.accts.invalidCred401",
        defaultMessage: "Your session has been interrupted. Please login again."
    }
});
export const AUTH = defineMessages({
    CONTINUE_SESSION: {
        id: "statusMessage.auth.continueSession",
        defaultMessage: "Your session has been continued. Your previous activity has been restarted."
    },
    FAIL_MESSAGE_PASSWORD_RESET: {
        id: "statusMessage.auth.failMessagePasswordReset",
        defaultMessage: "Your request to reset your password was not sent due to an error."
    },
    INTRO_CREATE_ACCOUNT: {
        id: "statusMessage.auth.introCreateAccount",
        defaultMessage: "Your account was not created due to this error:"
    },
    INTRO_LOGIN: {
        id: "statusMessage.auth.introLogin",
        defaultMessage: "You were not logged in due to this error:"
    },
    INTRO_PASSWORD: {
        id: "statusMessage.auth.introPassword",
        defaultMessage: "Your password was not saved due to this error:"
    },
    INTRO_PASSWORD_CHANGE: {
        id: "statusMessage.auth.introPasswordChange",
        defaultMessage: "Your password was not changed due to this error:"
    },
    INTRO_PASSWORD_FORGOT: {
        id: "statusMessage.auth.introPasswordForgot",
        defaultMessage: "Your request to reset your password was not sent due to this error:"
    },
    LOGOUT: {
        id: "statusMessage.auth.logout",
        defaultMessage: "You were successfully logged out of your account."
    },
    LOGOUT_401: {
        id: "statusMessage.auth.logout401",
        defaultMessage: "Your login has expired. Please login again."
    },
    PASSWORD_FORGOT_URL: {
        id: "statusMessage.auth.passwordForgotUrl",
        defaultMessage: "This URL has expired. Please use the Forgot Password link on the home page to submit a new request."
    },
    SUCCESS_MESSAGE_PASSWORD_CHANGED: {
        id: "statusMessage.auth.successMessagePasswordChanged",
        defaultMessage: "Your password has been updated successfully"
    },
    SUCCESS_MESSAGE_PASSWORD_FORGOT: {
        id: "statusMessage.auth.successMessagePasswordForgot",
        defaultMessage: "Your request to reset your password was sent successfuly."
    },
    SUCCESS_MESSAGE_PASSWORD_RESET: {
        id: "statusMessage.auth.successMessagePasswordReset",
        defaultMessage: "Your password was reset successfully."
    },
    /* For specific errors */
    INVALID_CRED_401: {
        id: "statusMessage.auth.invalidCred401",
        defaultMessage: "Invalid credentials. Please correct and try again."
    },
    INVALID_CRED_403: {
        id: "statusMessage.auth.invalidCred403",
        defaultMessage: "Invalid credentials. Please correct and try again."
    },
    ACCOUNT_LOCKED_409: {
        id: "statusMessage.auth.accountLocked409",
        defaultMessage: "Account is locked. Please use the Forgot Password link to unlock."
    },
    FORGOT_PASSWORD_BAD_URL_410: {
        id: "statusMessage.auth.forgotPasswordBadUrl410",
        defaultMessage: "Your password was not reset, because this URL is no longer valid. Please submit the Forgot Password form from the home page again."
    },
    CAPTCHA_INVALID_417: {
        id: "statusMessage.auth.captchaInvalid417",
        defaultMessage: "Could not validate captcha response."
    },
    CAPTCHA_REQUIRED_429: {
        id: "statusMessage.auth.captchaRequired429",
        defaultMessage: "Too many failed attempts. Captcha is required."
    },
    FORGOT_PASSWORD_RATE_LIMITED: {
        id: "statusMessage.auth.forgotPasswordRateLimited",
        defaultMessage: "Too many password reset requests. Please try again later."
    }
});
export const CONTACT = defineMessages({
    FAIL_MESSAGE_CONTACT: {
        id: "statusMessage.contact.failMessageContact",
        defaultMessage: "Your message was not sent due to an error."
    },
    INTRO_CONTACT: {
        id: "statusMessage.contact.introContact",
        defaultMessage: "Your message wasn't sent due to this error:"
    },
    SUCCESS_MESSAGE_CONTACT: {
        id: "statusMessage.contact.successMessageContact",
        defaultMessage: "Your message was successfully sent. Thank you."
    },
    DATA_LOAD_FAILED: {
        id: "statusMessage.contact.dataLoadFailed",
        defaultMessage: "An unexpected error occurred. Unable to send a message at this time."
    },
    /* For specific errors */
    CAPTCHA_INVALID_417: {
        id: "statusMessage.contact.captchaInvalid417",
        defaultMessage: "Could not validate captcha response."
    },
    CAPTCHA_REQUIRED_429: {
        id: "statusMessage.contact.captchaRequired429",
        defaultMessage: "Too many failed attempts. Captcha is required."
    }
});
export const EMAILOPTOUT = defineMessages({
    FAIL: {
        id: "statusMessage.emailOptOut.fail",
        defaultMessage: "Your request was not successful due to an error."
    },
    SUCCESS: {
        id: "statusMessage.emailOptOut.success",
        defaultMessage: "Please note that it may take up to one business day from receipt of this request for the update to be completed in our system."
    },
    DATA_LOAD_FAILED: {
        id: "statusMessage.emailOptOut.dataLoadFailed",
        defaultMessage: "An unexpected error occurred. Unable to update your preferences at this time."
    }
});
export const PROFILE = defineMessages({
    CREATE_ERROR_INTRO: {
        id: "statusMessage.profile.createErrorIntro",
        defaultMessage: "Your profile was not created due to this error:"
    },
    EDIT_ERROR_INTRO: {
        id: "statusMessage.profile.editErrorIntro",
        defaultMessage: "Your profile was not created due to this error:"
    },
    FAIL_MESSAGE_PROFILE: {
        id: "statusMessage.profile.failMessageProfile",
        defaultMessage: "Your profile was not saved due to this error:"
    },
    SUCCESS_MESSAGE_PROFILE: {
        id: "statusMessage.profile.successMessageProfile",
        defaultMessage: "Your profile has been saved successfully."
    }
});
export const VALIDATION = defineMessages({
    ADD_ACCOUNT_ERROR: {
        id: "statusMessage.validation.addAccountError",
        defaultMessage: "Your account was not added due to an error."
    },
    FAIL_MESSAGE_ADD: {
        id: "statusMessage.validation.failMessageAdd",
        defaultMessage: "Your account was not added due to an error. Your validation questions weren't answered correctly. Please try again."
    },
    INTRO_ADD_ACCOUNT: {
        id: "statusMessage.validation.introAddAccount",
        defaultMessage: "Your account was not added due to this error:"
    },
    INTRO_NEW_ACCOUNT: {
        id: "statusMessage.validation.introNewAccount",
        defaultMessage: "Your account could not be created due to this error:"
    },
    INTRO_REFER_AUTHORIZED_PARTY: {
        id: "statusMessage.validation.introReferAuthorizedParty",
        defaultMessage: "The information wasn't sent due to this error:"
    },
    INTRO_VALIDATION_ERROR: {
        id: "statusMessage.validation.introValidationError",
        defaultMessage: "Your account could not be validated due to this error:"
    },
    SUCCESS_MESSAGE_ADD: {
        id: "statusMessage.validation.successMessageAdd",
        defaultMessage: "The account was successfully added."
    },
    /* For specific errors */
    INCOMPLETE_400: {
        id: "statusMessage.validation.incomplete400",
        defaultMessage: "Required information was not completed."
    },
    LOGGED_IN_401: {
        id: "statusMessage.validation.loggedIn401",
        defaultMessage: "You must be logged in to use this action."
    },
    ACCOUNT_MISSING_404: {
        id: "statusMessage.validation.accountMissing404",
        defaultMessage: "The account you entered doesn't exist or the PIN is invalid."
    },
    EMAIL_IN_USE_412: {
        id: "statusMessage.validation.emailInUse412",
        defaultMessage: "The email address you supplied is already in use. Please try logging in."
    },
    CAPTCHA_INVALID_417: {
        id: "statusMessage.validation.captchaInvalid417",
        defaultMessage: "Could not validate captcha response."
    },
    CAPTCHA_REQUIRED_429: {
        id: "statusMessage.validation.captchaRequired429",
        defaultMessage: "Too many failed attempts. Captcha is required."
    },
    BAD_DATA_502: {
        id: "statusMessage.validation.badData502",
        defaultMessage: "This account cannot be added at present. Please contact us so we can resolve the issues."
    },
    USER_LIMIT_EXCEEDED_460: {
        id: "statusMessage.validation.userLimitExceeded460",
        defaultMessage: "This reference number has already been accessed by the maximum number of allowed users. Please call us for further information."
    },
    ACCOUNT_CLOSED_461: {
        id: "account.closed.message",
        defaultMessage: "We apologize for the inconvenience but we are unable to add this account. Please contact our office at 1-877-326-8786."
    },
    ACCOUNT_IN_2REG_451: {
        id: "statusMessage.validation.accountIn2reg",
        defaultMessage: "This account is not active in our office."
    }
});
export const PAYMENT = defineMessages({
    ACCOUNT_NOT_FOUND: {
        id: "statusMessage.payment.accountNotFound",
        defaultMessage: "Account not found"
    },
    CREATE_ERROR_INTRO: {
        id: "statusMessage.payment.createErrorIntro",
        defaultMessage: "Your payment was not processed due to this error:"
    },
    PAYMENT_FAILURE: {
        id: "statusMessage.payment.paymentFailure",
        defaultMessage: "A problem occurred while processing your payment. For assistance please contact DCM Services at the number above."
    },
    LOAD_RECEIPT_ERROR_INTRO: {
        id: "statusMessage.payment.loadReceiptErrorIntro",
        defaultMessage: "The payment information could not be loaded due to this error:"
    },
    PAYMENT_NOT_FOUND: {
        id: "statusMessage.payment.PaymentNotFound",
        defaultMessage: "Payment not found"
    }
});
/* tslint:enable:max-line-length */ 



// WEBPACK FOOTER //
// ./src/assets/scripts/constants/StatusMessages.ts